/**
 * FCM Navigation Handler Component
 * 
 * Handles navigation when notifications are clicked.
 * Uses centralized FCM context to avoid duplicate event listeners.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFCMNotifications } from '../../Contexts/FCMNotificationContext';

const FCMNavigationHandler = () => {
  const navigate = useNavigate();
  const { onNotificationClicked } = useFCMNotifications();

  useEffect(() => {
    // Register handler for notification clicks
    const unsubscribe = onNotificationClicked((data) => {
      console.log('[FCMNavigationHandler] Handling notification click:', data);
      
      // Navigate based on notification type and click action
      const clickAction = data?.click_action || data?.redirect_link;
      
      if (clickAction) {
        if (clickAction.startsWith('http')) {
          // External URL
          window.location.href = clickAction;
        } else {
          // Internal route - use React Router
          navigate(clickAction);
        }
      } else {
        // Default navigation based on notification type
        const subtype = data?.notification_subtype || data?.subtype;
        
        switch (subtype) {
          case 'relationship_request':
            navigate(data?.request_id ? `/chat?request=${data.request_id}` : '/chat?tab=requests');
            break;
          case 'coaching_session':
            navigate('/coach/individual');
            break;
          case 'assessment_reminder':
            navigate('/onboarding');
            break;
          case 'subscription_reminder':
            navigate('/manageMembership');
            break;
          default:
            try {
              navigate('/dashboard');
            } catch (_) {
              navigate('/dashboard');
            }
        }
      }
    });

    return unsubscribe;
  }, [navigate, onNotificationClicked]);

  // This component doesn't render anything
  return null;
};

export default FCMNavigationHandler;
